<template>
  <div class="box1"
       v-loading='loading'>
    <div class="items"
         v-for="(item,index) in datas"
         :key="index">
      <div class="item1">
        <span :class="item.titleColor=='-'?'titleRect gray':(item.titleColor=='0'?'titleRect red':'titleRect green')"></span>
        <span class="under"
              @click="openDig(item)"
              :title="item.title"><span>{{item.newTitle}}</span></span>
      </div>
      <div v-for="(items,i) in item.data"
           :key="i"
           class="item">
        <span class="zitiLeft"><span :title="items.name">{{items.name}}</span></span>
        <span class="zitiRght"
              v-if="items.name!='运行状态'">{{items.value}}{{items.unit}}</span>
        <span v-else
              :class="items.value=='-'?'zitiRect gray':(items.value=='0'?'zitiRect red':'zitiRect green')"></span>
      </div>
      <div class="item newItem">
        <!-- <span class="zitiLeft"></span> -->
        <img :src="item.imageUrl"
             class="imgBox">
      </div>

    </div>
    <!-- 弹出框 -->
    <win-dialog :dialog.sync="dialog"
                v-if="dialog.dialogVisible"></win-dialog>
    <!-- 弹出框 -->
  </div>

</template>

<script>
import configureCom from '@/components/page/configure/index'
export default {
  components: {
    WinDialog: configureCom.WinDialogNew,
  },
  props: {
    datas: {
      type: Array,
      default: () => {
        return []
      },
    },
    loading: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      dialog: {
        title: '', //弹窗标题
        btnIndex: 0, //当前按钮的选中
        dialogVisible: false, //弹窗显示状态
        ids: [],
        alarmInfo: [],
      },
    }
  },
  mounted() {},
  methods: {
    /* 打开计量点弹窗 */
    openDig(row) {
      this.dialog.ids = []
      this.dialog.title = row.title
      this.dialog.ids.push(row.id)
      this.dialog.dialogVisible = true
    },
  },
}
</script>
<style lang='less'
 scoped
>
.box1 {
  width: 100%;
  // height: 100%;
  // overflow: auto;
  // flex-flow: row;
  flex-wrap: wrap;
  padding: 0 10px 10px 0;
  box-sizing: border-box;
  // display: inline-grid;
  // grid-template-columns: repeat(5,1fr);
  display: flex;
}
.items {
  display: flex;
  border: 2px solid #000;
  padding: 14px;
  box-sizing: border-box;
  border-radius: 16px;
  //   height: 330px;
  width: 296px;
  flex-flow: column;
  margin: 10px 10px 0;
  margin-right: 0px;
  .item {
    display: flex;
    align-items: center;
    font-size: 16px;
    margin-bottom: 10px;
    justify-content: left;
    .zitiRght {
      color: #1c2ef5;
    }
    .zitiRect {
      height: 15px;
      width: 15px;
      border-radius: 50%;
    }
    .zitiLeft {
      width: 140px;
      text-align: left;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .imgBox {
      height: 130px;
      overflow: hidden;
      width: 100%;
    }
  }
  .newItem {
    justify-content: center;
  }
  .item1 {
    display: flex;
    align-items: center;
    margin-bottom: 36px;
    .under {
      font-size: 18px;
      font-weight: 600;
      max-width: 230px;
      cursor: pointer;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      text-align: left;
      text-decoration: none;
      border-bottom: 2px solid black;
      span {
        border-bottom: 4px solid #000;
      }
    }
    .titleRect {
      height: 24px;
      width: 24px;
      border-radius: 50%;
      margin-right: 6px;
    }
  }
}
.green {
  background: green;
}
.red {
  background: #f00;
}
.gray {
  background: gray;
}
</style>